import { extractSelectedTicketIdFromState } from 'extractFromState';
import { SET_CHAT_PRODUCT_REC_MACRO_COPIED, SET_CHAT_UI_STATUS } from './types';

export const setChatProductRecMacroCopied = (productRecMacroCopied) => (dispatch, getState) => {
  const ticketId = extractSelectedTicketIdFromState(getState());
  dispatch({
    type: SET_CHAT_PRODUCT_REC_MACRO_COPIED,
    payload: { ticketId, productRecMacroCopied },
  });
};

export const setChatUIStatus = (statusObj) => (dispatch, getState) => {
  dispatch({
    type: SET_CHAT_UI_STATUS,
    payload: statusObj,
  });
};
